import React from "react";
import Calculator from "./Calculator";

const DepositCalculatorBody = ({
  data,
  arrow_icon,
  buttonData,
  hero_images,
  keyword
}) => {
  return (
    <div>
      <Calculator
        data={data}
        arrow_icon={arrow_icon}
        buttonData={buttonData}
        hero_images={hero_images}
        keyword={keyword}
      />
    </div>
  );
};

export default DepositCalculatorBody;
